// src/services/settingsService.js
import api from './api';

const settingsService = {
  // ==================== COMPANY SETTINGS ====================
  
  // Obtener configuración de empresa
  getCompanySettings: async () => {
    try {
      const response = await api.get('/settings/company');
      return response.data;
    } catch (error) {
      console.error('Error al obtener configuración de empresa:', error);
      throw error;
    }
  },

  // Actualizar configuración de empresa
  updateCompanySettings: async (settings) => {
    try {
      const response = await api.put('/settings/company', settings);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar configuración de empresa:', error);
      throw error;
    }
  },

  // Subir logo de empresa
  uploadLogo: async (file) => {
    try {
      const formData = new FormData();
      formData.append('logo', file);
      
      // ✅ CORRECCIÓN: Eliminamos el header manual. 
      // Axios y el navegador pondrán el 'multipart/form-data' con el boundary correcto automáticamente.
      const response = await api.post('/settings/logo', formData);
      
      return response.data;
    } catch (error) {
      console.error('Error al subir logo:', error);
      throw error;
    }
  },

  // ==================== USER PREFERENCES ====================
  
  // Obtener preferencias de usuario
  getUserPreferences: async () => {
    try {
      const response = await api.get('/settings/preferences');
      return response.data;
    } catch (error) {
      console.error('Error al obtener preferencias:', error);
      throw error;
    }
  },

  // Actualizar preferencias de usuario
  updateUserPreferences: async (preferences) => {
    try {
      const response = await api.put('/settings/preferences', preferences);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar preferencias:', error);
      throw error;
    }
  },

  // ==================== HELPERS ====================
  
  // Obtener URL completa del logo
  getLogoUrl: (logoPath) => {
    if (!logoPath) return null;
    // Limpiamos la lógica redundante del env
    const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";
    // Aseguramos que no haya doble slash si la base termina en / y el path empieza con /
    const cleanBase = baseUrl.replace(/\/$/, '');
    const cleanPath = logoPath.startsWith('/') ? logoPath : `/${logoPath}`;
    
    return `${cleanBase}${cleanPath}`;
  },
};

export default settingsService;